import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ROUTE_PATH } from '../../constants';
import { useSelector } from 'react-redux';
import { sessionSelector } from '../../reducers/session';
import Contact, { Props as ContactProps } from './Contact';

const ContactOnboarding: React.FunctionComponent<ContactProps> = (props) => {
  return <Contact {...props} showOnboarding={true} />;
};
const ContactCST: React.FunctionComponent<ContactProps> = (props) => {
  return <Contact {...props} showOnboarding={false} />;
};

const ContactRouteManager: React.FunctionComponent = () => {
  const isOnboarding = useSelector(sessionSelector.isCustomerOnboarding);
  const handoffComplete = useSelector(sessionSelector.isHandoffComplete);
  const isPartiallyComplete = useSelector(sessionSelector.isPartiallyComplete);

  return (
    <Switch>
      {(isOnboarding || isPartiallyComplete) && (
        <Route
          data-cy="onboarding-route"
          path={ROUTE_PATH.CONTACT_ONBOARDING}
          component={ContactOnboarding}
        />
      )}
      {handoffComplete && (
        <Route
          data-cy="cst-route"
          path={ROUTE_PATH.CONTACT_CST}
          component={ContactCST}
        />
      )}
      {isOnboarding && !handoffComplete && (
        <Redirect
          data-cy="onboarding-redirect"
          to={ROUTE_PATH.CONTACT_ONBOARDING}
        />
      )}
      {handoffComplete && (
        <Redirect data-cy="cst-redirect" to={ROUTE_PATH.CONTACT_CST} />
      )}
      {!isOnboarding && !handoffComplete && (
        <Redirect data-cy="main-redirect" to={ROUTE_PATH.ONBOARDING.MAIN} />
      )}
    </Switch>
  );
};

export default ContactRouteManager;
